import { type HTMLArkProps, ark } from "@ark-ui/react";
import clsx from "clsx";
import * as React from "react";

interface BaseIconButtonProps extends HTMLArkProps<"button"> {
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

type FilledIconButtonProps = {
  variant: "primary";
  color: "primary";
};

type OtherIconButtonProps = {
  variant?: "secondary" | "tertiary" | "link";
  color?: "primary" | "gray";
};
type IconButtonProps = BaseIconButtonProps &
  (FilledIconButtonProps | OtherIconButtonProps);

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const {
      className,
      color = "primary",
      variant = "primary",
      size = "md",
      ...rest
    } = props;
    return (
      <ark.button
        ref={ref}
        type="button"
        data-variant={variant}
        data-color={color}
        data-size={size}
        className={clsx("ox-reset ox-IconButton", className)}
        {...rest}
      />
    );
  },
);

IconButton.displayName = "IconButton";
export { IconButton };
export type { IconButtonProps };
